/**
 * Parses an OPE MSRP-like value defensively: handles numbers, numeric
 * strings, empty strings, and non-numeric strings (which resolve to
 * `null` rather than `NaN`, so callers can safely coalesce with `?? 0`
 * without the comparator silently treating a bad value as a no-op sort).
 */
export function parseOpeMsrp(
    value: string | number | null | undefined,
): number | null {
    if (value === '' || value === undefined || value === null) {
        return null
    }

    const parsed = Number(value)

    return Number.isFinite(parsed) ? parsed : null
}

/**
 * Sorts OPE units by highest MSRP first, without mutating the input array.
 * Shared between the GET read-back conversion (convertCollateralValues.ts)
 * and the POST submission DTO builder (postOpeApplicationCollateralsAssets.ts)
 * so both agree on which unit is "primary" (highest MSRP).
 */
export function sortByHighestMsrp<T>(
    units: T[],
    getMsrp: (unit: T) => string | number | null | undefined,
): T[] {
    return [...units].sort((a, b) => {
        const firstMsrp = parseOpeMsrp(getMsrp(a)) ?? 0
        const secondMsrp = parseOpeMsrp(getMsrp(b)) ?? 0

        return secondMsrp - firstMsrp
    })
}
